document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-clas-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var wrap = button.closest('.clas-header-wrap');
      if (!wrap) return;
      var open = wrap.getAttribute('data-open') === 'true';
      wrap.setAttribute('data-open', open ? 'false' : 'true');
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  document.querySelectorAll('[data-clas-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.clas-carousel__track');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-clas-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-clas-dot]'));
    if (!track || slides.length < 2) return;

    var current = 0;
    var timer = null;
    var interval = parseInt(carousel.getAttribute('data-interval') || '4500', 10);
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var homeFade = carousel.hasAttribute('data-clas-home-fade');
    var hoverArea = homeFade ? carousel.closest('.clas-home-hero') || carousel : carousel;

    function show(index) {
      current = (index + slides.length) % slides.length;
      if (!homeFade) track.style.transform = 'translate3d(-' + (current * 100) + '%,0,0)';
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function advance() {
      show(current + 1);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (reducedMotion || document.hidden) return;
      stop();
      timer = window.setInterval(advance, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    if (!homeFade) {
      hoverArea.addEventListener('mouseenter', stop);
      hoverArea.addEventListener('mouseleave', start);
      hoverArea.addEventListener('focusin', stop);
      hoverArea.addEventListener('focusout', start);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    show(0);
    start();
  });


  var clasHeaderWrap = document.querySelector('.clas-header-wrap');
  if (clasHeaderWrap) {
    var updateClasHeader = function () {
      clasHeaderWrap.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    updateClasHeader();
    window.addEventListener('scroll', updateClasHeader, { passive: true });
  }
});

// v6 accordion: explicit button/panel toggling avoids conflicts with Horizon's details components.
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-clas-accordion-trigger]');
  if (!trigger) return;
  var panelId = trigger.getAttribute('aria-controls');
  if (!panelId) return;
  var panel = document.getElementById(panelId);
  if (!panel) return;
  var isOpen = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  if (isOpen) panel.setAttribute('hidden', ''); else panel.removeAttribute('hidden');
  var item = trigger.closest('.clas-accordion-item');
  if (item) item.classList.toggle('is-open', !isOpen);
});

// Cookie-policy controls: read and update consent only through Shopify's Customer Privacy API.
document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.querySelector('[data-clas-cookie-dialog]');
  var openButton = document.querySelector('[data-clas-cookie-open]');
  if (!dialog || !openButton) return;

  var status = dialog.querySelector('[data-clas-cookie-status]');
  var consentInputs = Array.prototype.slice.call(dialog.querySelectorAll('[data-clas-consent]'));

  function consentIsGranted(value) {
    return value === true || value === 'yes' || value === 'granted' || value === 'true';
  }

  function withPrivacyApi(callback) {
    function ready() {
      if (window.Shopify && window.Shopify.customerPrivacy) callback(window.Shopify.customerPrivacy);
      else if (status) status.textContent = status.getAttribute('data-error');
    }
    if (window.Shopify && window.Shopify.customerPrivacy) return ready();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error && status) status.textContent = status.getAttribute('data-error');
        else ready();
      });
    } else if (status) status.textContent = status.getAttribute('data-error');
  }

  function populate(api) {
    var current = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : {};
    consentInputs.forEach(function (input) {
      input.checked = consentIsGranted(current[input.getAttribute('data-clas-consent')]);
    });
  }

  function save(values) {
    withPrivacyApi(function (api) {
      api.setTrackingConsent(values, function (result) {
        if (result && result.error) {
          if (status) status.textContent = status.getAttribute('data-error');
          return;
        }
        if (status) status.textContent = status.getAttribute('data-saved');
        window.setTimeout(function () { if (dialog.open) dialog.close(); }, 650);
      });
    });
  }

  openButton.addEventListener('click', function () {
    if (status) status.textContent = '';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    withPrivacyApi(populate);
  });
  dialog.querySelector('[data-clas-cookie-close]').addEventListener('click', function () { dialog.close(); });
  dialog.querySelector('[data-clas-cookie-save]').addEventListener('click', function () {
    var values = {};
    consentInputs.forEach(function (input) { values[input.getAttribute('data-clas-consent')] = input.checked; });
    save(values);
  });
  dialog.querySelector('[data-clas-cookie-reject]').addEventListener('click', function () { save({ preferences: false, analytics: false, marketing: false }); });
  dialog.querySelector('[data-clas-cookie-accept]').addEventListener('click', function () { save({ preferences: true, analytics: true, marketing: true }); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
});


// CLAS language picker: submit Shopify's native localization form and remember manual choices.
document.addEventListener('click', function (event) {
  var option = event.target.closest('[data-clas-language-code]');
  if (!option || option.disabled) return;
  var form = option.closest('form');
  if (!form) return;
  var input = form.querySelector('[data-clas-language-input]');
  if (!input) return;
  var code = option.getAttribute('data-clas-language-code');
  input.value = code;
  form.submit();
});

// Automatic market and language redirection is handled by Shopify Markets.

document.addEventListener('click', function (event) {
  document.querySelectorAll('[data-clas-language-picker][open]').forEach(function (picker) {
    if (!picker.contains(event.target)) picker.removeAttribute('open');
  });
});

// Withdrawal form: record the visitor's local submission time as an additional form field.
document.addEventListener('submit', function (event) {
  var form = event.target.closest('.clas-withdrawal-form');
  if (!form) return;
  var input = form.querySelector('[data-clas-withdrawal-time]');
  if (!input) return;
  try { input.value = new Date().toISOString(); } catch (e) {}
});
